import { createIcons } from "lucide";
import {
  Accessibility,
  Anchor,
  Armchair,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  AtSign,
  Bath,
  BedDouble,
  Bike,
  BadgePercent,
  Calendar,
  CalendarClock,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  CloudSunRain,
  CookingPot,
  Compass,
  Droplets,
  Euro,
  Expand,
  ExternalLink,
  FileText,
  Flame,
  Flower2,
  Gift,
  Heart,
  HeartHandshake,
  Heater,
  House,
  Info,
  Leaf,
  List,
  Map,
  MapPin,
  Maximize2,
  Minus,
  Navigation,
  Palmtree,
  Parasol,
  PersonStanding,
  Phone,
  PlugZap,
  Plus,
  Play,
  Ruler,
  Route,
  Scale3d,
  ScanEye,
  Search,
  ShipWheel,
  Shrink,
  Shuffle,
  Sofa,
  Sparkles,
  Star,
  Sun,
  TriangleAlert,
  Users,
  UsersRound,
  UtensilsCrossed,
  Volume1,
  Wrench,
  Waves,
  X,
  Zap,
} from "lucide";

import { enhanceArrowLists } from "./arrow-list.js";

/**
 * Use in HTML as:
 *   <i data-lucide="chevron-left" aria-hidden="true"></i>
 *
 * When adding an icon, also add its slug to lib/lucide-icons.json
 * (powers the [Brick] Icon ACF select).
 */
function initLucideIcons() {
  enhanceArrowLists();

  createIcons({
    icons: {
      Accessibility,
      Anchor,
      Armchair,
      ArrowDown,
      ArrowLeft,
      ArrowLeftRight,
      ArrowRight,
      ArrowUp,
      AtSign,
      Bath,
      BedDouble,
      Bike,
      BadgePercent,
      Calendar,
      CalendarClock,
      CalendarDays,
      Check,
      ChevronDown,
      ChevronLeft,
      ChevronRight,
      Clock,
      CookingPot,
      Compass,
      CloudSunRain,
      Droplets,
      Euro,
      Expand,
      ExternalLink,
      FileText,
      Flame,
      Flower2,
      Gift,
      Heart,
      HeartHandshake,
      Heater,
      House,
      Info,
      Leaf,
      List,
      Map,
      MapPin,
      Maximize2,
      Minus,
      Navigation,
      Palmtree,
      Parasol,
      PersonStanding,
      Phone,
      PlugZap,
      Plus,
      Play,
      Ruler,
      Route,
      Scale3d,
      ScanEye,
      Search,
      ShipWheel,
      Shrink,
      Shuffle,
      Sofa,
      Sparkles,
      Star,
      Sun,
      TriangleAlert,
      Users,
      UsersRound,
      UtensilsCrossed,
      Volume1,
      Wrench,
      Waves,
      X,
      Zap,
    },
    attrs: {
      width: 20,
      height: 20,
    },
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLucideIcons);
} else {
  initLucideIcons();
}
